// @flow
import type { Untranslated } from '@rover/shared/js/types/Translation';
import type { ErrorContext } from '@rover/react-lib/types/ErrorContext';
import { captureException, withScope } from '@rover/utilities/sentry';

type ErrorType = Error | Untranslated;

function getErrorObject(error: ErrorType): Error {
  if (typeof error === 'string') {
    return new Error(error);
  } else if (error instanceof Error) {
    return error;
  }
  return new Error(error.id);
}

const reportError = (error: ErrorType, errorContext?: ErrorContext) => {
  const errorObject: Error = getErrorObject(error);
  if (process.env.NODE_ENV === 'development') throw errorObject;

  withScope(scope => {
    scope.setExtras({ stacktrace: errorObject.stack });
    captureException(errorObject, errorContext);
  });
};

export default reportError;



// WEBPACK FOOTER //
// ../utilities/reportError.js